import i18n from "@/i18n";

function enumToSelectOptions(codes, labels, from, to) {
  let options = [];
  for (let i = 0; i < codes.length; i++) {
    let code = codes[i];
    let label = labels[i];
    if (from !== undefined && code < from) continue;
    if (to !== undefined && code >= to) continue;
    options.push({ value: code, text: label });
  }
  return options;
}

function enumCodeToLabel(codes, labels, code) {
  const index = codes.indexOf(code);
  return index !== -1 ? labels[index] : "";
}

function enumLabelToCode(codes, labels, label) {
  const index = labels.indexOf(label);
  return index !== -1 ? codes[index] : "";
}

export class BaseEnum {
  static Codes = [];
  static _labelKeys = [];

  static get Labels() {
    return this._labelKeys.map((key) => i18n.t(key));
  }

  static toSelectOptions(from, to) {
    return enumToSelectOptions(this.Codes, this.Labels, from, to);
  }

  static codeToLabel(code) {
    return enumCodeToLabel(this.Codes, this.Labels, code);
  }

  static labelToCode(label) {
    return enumLabelToCode(this.Codes, this.Labels, label);
  }
}

export class BaseEnumStatic {
  static Codes = [];
  static Labels = [];

  static toSelectOptions(from, to) {
    return enumToSelectOptions(this.Codes, this.Labels, from, to);
  }

  static codeToLabel(code) {
    return enumCodeToLabel(this.Codes, this.Labels, code);
  }

  static labelToCode(label) {
    return enumLabelToCode(this.Codes, this.Labels, label);
  }
}

export { enumToSelectOptions, enumCodeToLabel, enumLabelToCode };
